<script setup lang="ts">

const { theme } = useAppConfig()

const props = withDefaults(defineProps<{
  name: string | Array<string> | undefined,
  bgColor?: string,
  color?: string,
  type?: string,
  isClick?: boolean,
  clickMode?: string,
  showAll?: boolean
}>(), {
  type: 'rect',
  isClick: false,
  clickMode: 'single',
  showAll: false,
  bgColor: 'var(--tag-bg)',
  color: 'var(--bold-color)'
})

const emits = defineEmits(['tagChange'])

const tagsArray = computed<string[]>(() => {
  let result: string[] = []
  if (!props.name) return result
  if (typeof props.name !== 'string') {
    props.showAll && props.name.unshift('全部')
    result.push(...props.name)
  } else {
    result.push(...props.name?.split('、'))
    props.showAll && result.unshift('全部')
  }
  return result ?? []
})

const activeTag = defineModel<string[]>({ default: [] })

function onTagClick(tag: string) {
  if (props.clickMode === 'single') {
    if (!activeTag.value.includes(tag)) {
      activeTag.value.length = 0
      activeTag.value.push(tag)
    } else {
      activeTag.value.length = 0
    }
  } else {
    if (!activeTag.value.includes(tag)) {
      activeTag.value.push(tag)
    } else {
      activeTag.value = activeTag.value.filter(item => {
        return item !== tag
      })
    }
  }
  emits('tagChange', activeTag.value)
}
</script>

<template>
  <div class="base-tag inline-block flex flex-wrap gap-row-10px">
    <span v-if="tagsArray.length" v-for="(tag, index) in tagsArray" :key="`tag-${index}-${tag}`"
      class="inline-block text-12px p-5px pl-12px pr-12px flex-shrink-0"
      :class="{ 'tag-hover': isClick, 'active-tag': activeTag.includes(tag), 'mr-10px': index !== tagsArray.length - 1}" @click="onTagClick(tag)"
      :style="{ backgroundColor: props.bgColor, color: props.color, borderRadius: props.type === 'rect' ? '4px' : '12px', cursor: isClick ? 'pointer' : 'default' }">
      <slot>{{ tag }}</slot>
    </span>
  </div>
</template>

<style scoped lang="scss">
.base-tag {

  .tag-hover:hover,
  .active-tag {
    background: var(--icon-bg) !important;
    color: #FFFFFF !important;
  }
}
</style>